import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Link,
  Typography
} from '@mui/material';
import { getCurrentTOSVersion } from '../utils/termsVersion';

interface TermsOfServiceModalProps {
  open: boolean;
  onAccept: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({
  open,
  onAccept
}) => {
  const [accepted, setAccepted] = useState(false);
  const tosVersion = getCurrentTOSVersion();

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAccepted(event.target.checked);
  };

  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };

  return (
    <Dialog open={open} aria-labelledby="terms-of-service-dialog-title" maxWidth="md">
      <DialogTitle id="terms-of-service-dialog-title">
        Terms of Service Agreement
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          Before continuing to use our services, please review and accept our Terms of Service.
        </Typography>
        <Box mb={2}>
          <Link href="/legal/terms-of-service" target="_blank" rel="noopener">
            Read our Terms of Service
          </Link>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={accepted}
              onChange={handleCheckboxChange}
              name="acceptTerms"
              color="primary"
            />
          }
          label={`I have read and agree to the Terms of Service (version: ${tosVersion})`}
        />
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={handleAccept} 
          color="primary" 
          variant="contained"
          disabled={!accepted}
        >
          Accept and Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfServiceModal;